import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { CommonModule } from "@angular/common";
import { NgChartsModule } from "ng2-charts";
import { Ng2GoogleChartsModule } from "ng2-google-charts";
import { NgxChartsModule } from "@swimlane/ngx-charts";
import { ChartistModule } from "ng-chartist";
import { SharedModule } from "../../shared/shared.module";
import { NgbCollapseModule } from "@ng-bootstrap/ng-bootstrap";
import { IntegracionesRoutingModule } from "./integraciones-routing.module";
import { ServiciosExternosComponent } from "./servicio-externos/servicios-externos.component";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { MonacoEditorModule } from "ngx-monaco-editor-v2";

// CONFIGURADOR DE SERVICIOS
import { ConfiguracionServiciosComponent } from "./config-servicios/config-servicios.component";
// PANELES DE SERVICIO
import { ServiciosComponent } from "./servicios-paneles/servicio-externo/servicio.component";
import { BucketComponent } from "./servicios-paneles/bucket/bucket.component";
import { ArchivoConfiguracionComponent } from "./servicios-paneles/archivo-configuracion/archivo-configuracion";
import { ListBucketComponent } from "./servicios-paneles/bucket/list-bucket/list-bucket.component";
import { ListFlujoComponent } from "./servicios-paneles/flujo/list-flujo/list-flujo.component";
import { FlujoComponent } from "./servicios-paneles/flujo/flujo.component";

@NgModule({
  declarations: [
    ServiciosExternosComponent,
    ServiciosComponent,
    BucketComponent,
    ArchivoConfiguracionComponent,
    ConfiguracionServiciosComponent,
    ListBucketComponent,
    ListFlujoComponent,
    FlujoComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    NgChartsModule,
    Ng2GoogleChartsModule,
    NgxChartsModule,
    ChartistModule,
    NgbCollapseModule,
    IntegracionesRoutingModule,
    ReactiveFormsModule,
    FormsModule,

    MonacoEditorModule.forRoot(),
  ],
  exports: [ServiciosComponent, BucketComponent, ArchivoConfiguracionComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class IntegracionesModule {}
